import { matchPath, useLocation } from 'react-router-dom';
import { ReporterRoutePath } from '../config/constants';
import { generateNestedReporterUrl } from 'utils/urls';

export const useReporterSubPath = (): Nullable<ReporterRoutePath> => {
  const location = useLocation();

  const paths = [
    ReporterRoutePath.MACRO_NEW,
    ReporterRoutePath.MACRO_CLONE,
    ReporterRoutePath.MACRO_EDIT,
    ReporterRoutePath.TEMPLATE_NEW,
    ReporterRoutePath.TEMPLATE_CLONE,
    ReporterRoutePath.TEMPLATE_EDIT,
  ];

  return paths.find(
    (path) =>
      matchPath(generateNestedReporterUrl(path), location.pathname) != null ||
      matchPath(generateNestedReporterUrl(path, true), location.pathname) != null
  );
};
